import React, { Component } from 'react';

import LoadingIndication from '../../common/loading-indicator';
import adminStatsService from '../../../services/admin-stats/admin-stats';

class InstagramTotals extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading1: true,
      isLoading2: true,
      isError: false,      
      stats: [],
    };
  }

  componentDidMount() {
    adminStatsService.getInstagramTotals1()
      .then((stats) => {
        this.setState(({ stats: currStats = [] }) => ({
          stats: [...currStats, ...stats],
          isLoading1: false,
          isError: false
        })); 
      })
      .catch(error => {
        console.error('InstagramTotals::componentDidMount', error);
        this.setState({
          isLoading1: false,
          isLoading2: false,
          isError: true
        });
      });

    adminStatsService.getInstagramTotals2()
      .then((stats) => {
        this.setState(({ stats: currStats = [] }) => ({
          stats: [...currStats, ...stats],
          isLoading2: false,          
          isError: false
        })); 
      })
      .catch(error => {
        console.error('InstagramTotals::componentDidMount', error);
        this.setState({
          isLoading1: false,
          isLoading2: false,
          isError: true
        });
      });      
  }

  render() {
    const { stats = [] } = this.state;

    return (
      <div style={{ margin: '30px 0' }}>
        {
          this.state.isError && <div>Error</div>
        }
        
        {
          (this.state.isLoading1 || this.state.isLoading2) && <span>Loading...</span>
        }

        {
          stats.map(({ title, value }) => (
            <div><b>{ title }</b>: {value}</div>
          ))
        }
      </div>
    );
  }
}

export default InstagramTotals;
